// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"47":"pricing","207":"full-integration-modern","335":"uds","346":"initial-payment-calc","448":"esntial-uds","675":"full-integration-legacy","677":"uds-legacy"}[chunkId] || chunkId) + ".min.js";
};